import { forwardRef, useEffect, useImperativeHandle } from "react";
import { DataTable } from "primereact/datatable";
import { useAPIGetKendaraanService } from "../api/api-get-kendaraan-service";
import { Column } from "primereact/column";
import ServiceFilter from "./kendaraan-service-filter";
import {
  genTemplateBodyNumber,
  genTemplateBodyText,
} from "../../../../components/utils/TableTemplateBodyGenerator";
import { Paginator } from "primereact/paginator";
import { Button } from "primereact/button";

const KendaraanServiceList = forwardRef((props, ref) => {
  const { onClickRowDelete, onClickRowEdit, onClickAddNew } = props;

  const {
    loading,
    listData,
    fetchListData,
    filterValue,
    setFilterValue,
    handleOnClickRefresh,
    handleOnPage,
    paging,
    handleOnUpdateViewRow,
    handleOnDeleteViewRow,
  } = useAPIGetKendaraanService();

  useImperativeHandle(ref, () => ({
    handleOnUpdateViewRow: (row) => {
      handleOnUpdateViewRow(row);
    },
    handleOnDeleteViewRow: (row) => {
      handleOnDeleteViewRow(row);
    },
  }));

  // use effect section

  // useEffect(() => {
  //   fetchListData({ page: paging.page, take: paging.take });
  // }, []);

  // other function

  const refineServiceName = (rawName) => {
    return rawName
      .toUpperCase()
      .replaceAll("CHECK", "")
      .replaceAll("SERIVCE", "")
      .replaceAll("GANTI", "")
      .trim();
  };

  //  custom ui section

  const nomorPolisiBodyTemplate = (row) => {
    return genTemplateBodyText({
      row: row,
      field: "nomor_polisi",
    });
  };

  const jenisMobilBodyTemplate = (row) => {
    return genTemplateBodyText({
      row: row,
      field: "jenis_mobil",
    });
  };

  const serviceBodyTemplate = (row) => {
    const { data_services } = row;
    if (data_services && data_services.length > 0) {
      return (
        <div className="row-start-center gap-2 flex-wrap">
          {data_services.map((el, index) => {
            return (
              <span
                key={el.id}
                className="text-xs font-semibold text-white bg-slate-400 rounded-md px-2 py-1"
              >
                {refineServiceName(el.nama)}
              </span>
            );
          })}
        </div>
      );
    } else {
      return "";
    }
  };

  const actionBodyTemplate = (row) => {
    return (
      <div className="row-center-center gap-2">
        <Button
          icon={row.id && row.id > 0 ? "pi pi-pencil" : "pi pi-plus"}
          rounded
          severity={row.id && row.id > 0 ? "primary" : "success"}
          className={`${
            row.id && row.id > 0 ? "bg-indigo-400" : "bg-emerald-400"
          } max-w-[1.85rem] max-h-[1.85rem]`}
          onClick={() => {
            if (onClickRowEdit) onClickRowEdit(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
      </div>
    );
  };

  return (
    <div className="col-start-start w-full gap-4">
      {/* filter section */}
      <div className="elevated-card-tight-vertical row-start-start w-full gap-4">
        <ServiceFilter
          filterValue={filterValue}
          setFilterValue={setFilterValue}
          onClickRefresh={handleOnClickRefresh}
        />
      </div>

      {/* table section */}
      <div className="elevated-card-tight-vertical col-start-end w-full gap-2">
        <div className="row-start-center w-full"></div>
        <DataTable
          dataKey="id"
          className="w-100"
          loading={loading}
          showGridlines
          stripedRows
          value={listData}
        >
          <Column
            field="no"
            header="#"
            className="text-center"
            headerClassName="w-[4rem]"
            alignHeader={"center"}
          />
          <Column
            field=""
            header="Action"
            alignHeader={"center"}
            headerClassName="w-[6rem]"
            body={actionBodyTemplate}
          />
          <Column
            field="nomor_polisi"
            header="Nomor Polisi"
            headerClassName="w-[9rem]"
            // headerClassName="w-[4rem]"
            body={nomorPolisiBodyTemplate}
          />
          <Column
            field="jenis_mobil"
            header="Jenis"
            headerClassName="w-[12rem]"
            body={jenisMobilBodyTemplate}
          />
          <Column header="Service" body={serviceBodyTemplate} />
        </DataTable>
        <Paginator
          first={parseInt(paging.take) * (paging.page - 1)}
          rows={parseInt(paging.take)}
          totalRecords={parseInt(paging.total)}
          rowsPerPageOptions={[5, 10, 20, 50]}
          onPageChange={handleOnPage}
        />
      </div>
    </div>
  );
});

export default KendaraanServiceList;
